module.exports = __webpack_public_path__ + "img/vertical_7_4_3016.511bc868.png";